import React from 'react';
import {
    Box, IconButton, Menu, MenuItem
} from '@deere/fuel-react';
import MoreVert from "@material-ui/icons/MoreVert";
import {makeStyles} from "@material-ui/core/styles";
import {EDIT_COMMENT, MENU_ADD_COMMENT, MENU_OVERRIDE, MENU_QUESTION_NA, MENU_EDIT_OVERRIDE, MENU_EDIT_QUESTION_NA} from "../shared/Constants";

const useStyles = makeStyles(() => ({
    list: {
        padding: '0.5rem !important',
    },
}));

export const RatingsActions = ({
                                   anchorEl,
                                   isRequired = false,
                                   isComments = false,
                                   isObjective = false,
                                   isEdit = false,
                                   onActionsClick,
                                   onClose,
                                   onCommentsClick,
                                   onOverrideScoreClick,
                                   overrideEdit = false,
                                   onNotApplicableClick,
                                   notApplicableEdit = false,
                                   onCategoryCommentClick,
                                   isCommentsEdit = false,
                                   categoryId
                               }) => {
    const classes = useStyles();
    const open = Boolean(anchorEl);

    const handleAddComment = () => {
        onCommentsClick("add");
    };

    const handleEditComment = () => {
        onCommentsClick("edit");
    };

    const handleOverrideScore = () => {
        onOverrideScoreClick("add");
    }

    const handleEditOverrideScore = () => {
        onOverrideScoreClick("edit");
    }

    const handleNotApplicable = () => {
        onNotApplicableClick("add");
    }

    const handleEditNotApplicable = () =>{
        onNotApplicableClick("edit")
    }

    const handleCategoryAddComment = () =>{
        onCategoryCommentClick("add", categoryId);
    }

    const handleCategoryEditComment = () => {
        onCategoryCommentClick("edit", categoryId);
    }

    return (
        <Box display="flex"
             justifyContent="center" alignSelf="flex-start" pt={isComments ? 0 : 3}>
            <IconButton style={{padding: 0}} aria-label="more" onClick={onActionsClick} size="small">
                <MoreVert/>
            </IconButton>
            {isComments ?
                <Menu
                    id="long-menu"
                    anchorEl={anchorEl}
                    open={open}
                    keepMounted
                    getContentAnchorEl={null}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    onClose={onClose}
                >
                    {!isCommentsEdit &&
                        <MenuItem
                            key={1}
                            className={classes.list}
                            divider={!isComments}
                            onClick={handleCategoryAddComment}>
                            {"Add a Comment"}
                        </MenuItem>
                    }
                    {isCommentsEdit &&
                        <MenuItem
                            key={1}
                            className={classes.list}
                            divider={!isComments}
                            onClick={handleCategoryEditComment}>
                            {"Edit Comment"}
                        </MenuItem>
                    }
                </Menu> :
                <Menu
                    id="long-menu"
                    anchorEl={anchorEl}
                    open={open}
                    keepMounted
                    getContentAnchorEl={null}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    onClose={onClose}
                >
                    {!isObjective && isEdit &&
                    <MenuItem
                        key={1}
                        className={classes.list}
                        divider={!isComments}
                        onClick={handleEditComment}>
                        {EDIT_COMMENT}
                    </MenuItem>
                    }
                    {!isObjective && !isEdit &&
                    <MenuItem
                        key={1}
                        className={classes.list}
                        divider={!isComments}
                        onClick={handleAddComment}>
                        {MENU_ADD_COMMENT}
                    </MenuItem>
                    }
                    {!isObjective && !overrideEdit &&
                    <MenuItem
                        key={2}
                        className={classes.list}
                        disabled={notApplicableEdit}
                        divider={true}
                        onClick={handleOverrideScore}>
                        {MENU_OVERRIDE}
                    </MenuItem>
                    }
                    {!isObjective && overrideEdit &&
                    <MenuItem
                        key={2}
                        className={classes.list}
                        divider={true}
                        onClick={handleEditOverrideScore}>
                        {MENU_EDIT_OVERRIDE}
                    </MenuItem>
                    }
                    {!notApplicableEdit &&
                        <MenuItem
                            key={3}
                            className={classes.list}
                            disabled={isRequired || overrideEdit}
                            onClick={handleNotApplicable}
                            divider={false}>
                            {MENU_QUESTION_NA}
                        </MenuItem>
                    }
                    {notApplicableEdit &&
                        <MenuItem
                            key={3}
                            className={classes.list}
                            disabled={isRequired}
                            onClick={handleEditNotApplicable}
                            divider={false}>
                            {MENU_EDIT_QUESTION_NA}
                        </MenuItem>
                    }
                </Menu>
            }
        </Box>
    );
}
